import { RequestKind, boolean, string } from '@sb/library/base';
import { DisplayItemCollection, PayPalCommercePlatformCreateOrderInputItem, PayPalCommercePlatformCreateTokenInputItem, PayPalCommercePlatformCreateVaultSetupTokenInputItem, PayPalCommercePlatformOrderResultItem, PayPalCommercePlatformPartnerReferralInputItem, PayPalCommercePlatformTokenResultItem, PaymentCompleteInputItem, PaymentDetailsDisplayItem, PaymentProcessorDisplayItem, PaymentProcessorInputItem, PaymentProcessorSearchOptions, PaymentProcessorUpdateItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace PaymentProcessorRoutes {
    export const Get = ApiRoute.Define({
        URL: (paymentProcessorID: string) => `paymentprocessors/${paymentProcessorID}`,
        Kind: RequestKind.Get,
        ResultType: PaymentProcessorDisplayItem
    });

    export const GetDetails = ApiRoute.Define({
        URL: 'paymentprocessors/getpaymentdetails',
        Kind: RequestKind.Post,
        BodyType: PaymentCompleteInputItem,
        ResultType: PaymentDetailsDisplayItem
    });

    export const GetAll = ApiRoute.Define({
        URL: 'paymentprocessors',
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection<PaymentProcessorDisplayItem>,
        PagingAllowed: true
    });

    export const Search = ApiRoute.Define({
        URL: 'search/paymentprocessors',
        Kind: RequestKind.Post,
        BodyType: PaymentProcessorSearchOptions,
        ResultType: DisplayItemCollection<PaymentProcessorDisplayItem>,
        PagingAllowed: true
    });

    export const Add = ApiRoute.Define({
        URL: 'paymentprocessors',
        Kind: RequestKind.Post,
        BodyType: PaymentProcessorInputItem,
        ResultType: string
    });

    export const Update = ApiRoute.Define({
        URL: (paymentProcessorID: string) => `paymentprocessors/${paymentProcessorID}`,
        Kind: RequestKind.Put,
        BodyType: PaymentProcessorUpdateItem,
        ResultType: string
    });

    export const Delete = ApiRoute.Define({
        URL: (paymentProcessorID: string) => `paymentprocessors/${paymentProcessorID}`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });

    export namespace PayPal {
        export namespace CommercePlatform {
            export const GetPartnerReferralUrl = ApiRoute.Define({
                URL: 'paymentprocessors/paypalcommerceplatformpartnerreferralurl',
                Kind: RequestKind.Post,
                BodyType: PayPalCommercePlatformPartnerReferralInputItem,
                ResultType: string
            });

            export const CreateTokens = ApiRoute.Define({
                URL: (schoolID: string, paymentProcessorID: string) =>
                    schoolID
                        ? `schools/${schoolID}/paymentprocessors/${paymentProcessorID}/paypalcommerceplatformtokens`
                        : `paymentprocessors/${paymentProcessorID}/paypalcommerceplatformtokens`,
                Kind: RequestKind.Post,
                BodyType: PayPalCommercePlatformCreateTokenInputItem,
                ResultType: PayPalCommercePlatformTokenResultItem
            });

            export const CreateOrder = ApiRoute.Define({
                URL: (schoolID: string, paymentProcessorID: string) =>
                    schoolID
                        ? `schools/${schoolID}/paymentprocessors/${paymentProcessorID}/paypalcommerceplatformorder`
                        : `paymentprocessors/${paymentProcessorID}/paypalcommerceplatformorder`,
                Kind: RequestKind.Post,
                BodyType: PayPalCommercePlatformCreateOrderInputItem,
                ResultType: PayPalCommercePlatformOrderResultItem
            });

            export const CreateVaultSetupToken = ApiRoute.Define({
                URL: (schoolID: string, paymentProcessorID: string) =>
                    schoolID
                        ? `schools/${schoolID}/paymentprocessors/${paymentProcessorID}/paypalcommerceplatformvaultsetuptoken`
                        : `paymentprocessors/${paymentProcessorID}/paypalcommerceplatformvaultsetuptoken`,
                Kind: RequestKind.Post,
                BodyType: PayPalCommercePlatformCreateVaultSetupTokenInputItem,
                ResultType: string
            });
        }
    }

    export namespace StripeConnect {
        export const GetUrl = ApiRoute.Define({
            URL: 'paymentprocessors/stripeconnect',
            Kind: RequestKind.Get,
            ResultType: string
        });
    }
}
